/* This file was automatically generated by tools management permissions. It should not be changed manually. */
import {REG} from "lib/commons/registry";
import "lib/store/store_Perms";

const r = REG.reg;
r.newPerm("action.store#add.folder", "upload.UTNode.content", 0);
r.newPerm("action.store#add.res", "upload.UTNode.content", 0);
r.newPerm("action.store#edit.metasRes", "edit.UTNode.metas", 0);
r.newPerm("action.store#edit.res.perms", "admin.UTNode.configRoles", 0);
r.newPerm("action.store#import.res", "upload.UTNode.content", 0);
r.newPerm("action.store#moveFrom.res", "edit.UTNode.metas", 0);
r.newPerm("action.store#relist.res", "write.UTNode.relist", 0);
r.newPerm("action.store#remove.res", "write.UTNode.remove", 0);
r.newPerm("action.store#rename.res", "edit.UTNode.metas", 0);
r.newPerm("action.store#trash.res", "write.UTNode.trash", 0);
r.newPerm("action.store#unlist.res", "write.UTNode.unlist", 0);
r.newPerm("action.store#untrash.res", "write.UTNode.untrash", 0);
